import fullpageInitialize from '../modules/fullpage-init';

const initialize = () => {
    fullpageInitialize();
};

export default initialize;
